import defaultAttributes from '../defaultAttributes';

const Clipboard = [
  'svg',
  defaultAttributes,
  [
    [
      'path',
      {
        d: 'M16 4h2a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2V6a2 2 0 012-2h2',
      },
    ],
    ['rect', { x: '8', y: '2', width: '8', height: '4', rx: '1', ry: '1' }],
  ],
];

export default Clipboard;
